document.addEventListener('DOMContentLoaded', function () {
    const phoneContainer = document.querySelector('.dkphoneproductpot');
    if (!phoneContainer) return;

    const phoneUI = {
      title: phoneContainer.querySelector('#phone-product-title'),
      img: phoneContainer.querySelector('#phone-product-img'),
      link: phoneContainer.querySelector('#phone-product-link'),
      price: phoneContainer.querySelector('#phone-product-price'),
      comparePrice: phoneContainer.querySelector('#phone-product-compare-price'),
      shopNow: phoneContainer.querySelector('#phone-shop-now'),
      btn: phoneContainer.querySelector('#phone-quickview-btn'),
    };

    // 2. 核心注入函数
    function injectProductInfo(dotElement) {
      // 从当前点击的点中提取数据
      const sourceBtn = dotElement.querySelector('.quickview-btn');
      const sourceImg = dotElement.querySelector('.producthotmedia img');
      const sourceTitle = dotElement.querySelector('h4').textContent;
      const sourceUrl = dotElement.querySelector('.producthotmedia').getAttribute('href');
      const sourcePrice = dotElement.querySelector('.hotpotprice p').textContent;
      const sourceComparePrice = dotElement.querySelector('.hotpotprice span').textContent;

      // 执行注入
      phoneUI.title.textContent = sourceTitle;
      phoneUI.img.src = sourceImg.src;
      phoneUI.img.alt = sourceTitle;
      phoneUI.link.href = sourceUrl;
      phoneUI.shopNow.href = sourceUrl;
      phoneUI.price.textContent = sourcePrice;
      phoneUI.comparePrice.textContent = sourceComparePrice;

      // 重要：同步 data 属性，确保手机端按钮点击时 Quickview 依然有效
      // 我们遍历 sourceBtn 的所有 dataset 并赋给手机端按钮
      Object.keys(sourceBtn.dataset).forEach((key) => {
        phoneUI.btn.dataset[key] = sourceBtn.dataset[key];
      });

      // 视觉反馈：高亮当前选中的点
      document.querySelectorAll('.productdot').forEach((d) => d.classList.remove('is-active'));
      dotElement.classList.add('is-active');
    }

    // 3. 绑定点击事件 (针对 dkhotpotout 圆圈)
    const allDots = document.querySelectorAll('.productdot');
    allDots.forEach((dot) => {
      // 监听整个点或者内部的圆圈
      dot.querySelector('.dkhotpotout').addEventListener('click', function (e) {
        e.preventDefault();
        injectProductInfo(dot);
      });
    });

    // 4. 默认初始化：加载第一个产品信息
    if (allDots.length > 0) {
      injectProductInfo(allDots[0]);
    }
  });